import { useSyncExternalStore } from 'react';
import type { DelayedQuote } from '@benzinga/quotes-manager';

import { readPortfolioShellSnapshot } from '../../(site)/profile/portfolio/_components/portfolioShellSnapshot';

export type PortfolioQuoteBarDetail = {
  quotes?: Record<string, DelayedQuote>;
  tickers: string[];
};

type PortfolioQuoteBarListener = (detail: PortfolioQuoteBarDetail | null) => void;

let liveDetail: PortfolioQuoteBarDetail | null | undefined;
let snapshotDetail: PortfolioQuoteBarDetail | null = null;
let snapshotTickersKey = '';
const listeners = new Set<() => void>();

const notify = () => {
  listeners.forEach(listener => listener());
};

export function publishPortfolioQuoteBar(detail: PortfolioQuoteBarDetail | null): void {
  liveDetail = detail;
  notify();
}

export function getVisiblePortfolioQuoteBar(): PortfolioQuoteBarDetail | null {
  if (liveDetail !== undefined) {
    return liveDetail;
  }
  const tickers = readPortfolioShellSnapshot()?.quoteBarTickers ?? [];
  const tickersKey = tickers.join(',');
  if (tickersKey === snapshotTickersKey) {
    return snapshotDetail;
  }
  snapshotTickersKey = tickersKey;
  snapshotDetail = tickers.length > 0 ? { tickers } : null;
  return snapshotDetail;
}

export function resetPortfolioQuoteBar(): void {
  liveDetail = undefined;
  snapshotDetail = null;
  snapshotTickersKey = '';
}

export function subscribePortfolioQuoteBar(listener: PortfolioQuoteBarListener): () => void {
  const onStoreChange = () => {
    listener(getVisiblePortfolioQuoteBar());
  };
  listeners.add(onStoreChange);
  onStoreChange();
  return () => {
    listeners.delete(onStoreChange);
  };
}

const subscribeQuoteBarStore = (onStoreChange: () => void): (() => void) => {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
};

const getServerQuoteBar = (): PortfolioQuoteBarDetail | null => null;

export const usePortfolioQuoteBarDetail = (): PortfolioQuoteBarDetail | null =>
  useSyncExternalStore(subscribeQuoteBarStore, getVisiblePortfolioQuoteBar, getServerQuoteBar);
